import React from 'react';
import { AppBar, Box, Button, Container, Toolbar, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import logo from '../../Assets/logo.png';

const PublicHeader = () => {
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: '#ffffff',
        color: '#102a43',
        borderBottom: '1px solid #e7ecf3',
      }}
    >
      <Container maxWidth="lg">
        <Toolbar sx={{ px: { xs: 0, sm: 1 }, minHeight: '68px !important' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexGrow: 1 }}>
            <Box
              component="img"
              src={logo}
              alt="Nuvvy logo"
              sx={{ width: 38, height: 38, objectFit: 'contain' }}
            />
            <Typography variant="h6" sx={{ fontWeight: 800 }}>
              Nuvvy
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Button component={RouterLink} to="/" color="inherit">
              المنيو
            </Button>
            <Button component={RouterLink} to="login" variant="contained">
تسجيل الدخول            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default PublicHeader;
